import { render, staticRenderFns } from "./Dashboard-backup.vue?vue&type=template&id=12eda9d3&scoped=true&"
import script from "./Dashboard-backup.vue?vue&type=script&lang=js&"
export * from "./Dashboard-backup.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-backup.vue?vue&type=style&index=0&id=12eda9d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eda9d3",
  null
  
)

export default component.exports